export default __webpack_public_path__ + "static/media/ppcp-white.83d86012.jpg";